module.exports = __webpack_public_path__ + "static/media/vender2.8e577fbb.svg";